export const API_BASE_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
export const STATIC_BASE_URL = (process.env.REACT_APP_STATIC_URL || '').replace(/\/$/, '');
export const TENANT_COMPANY_NAME = (process.env.REACT_APP_TENANT_COMPANY_NAME || '').trim();
export const TENANT_BASE_DOMAIN = (process.env.REACT_APP_TENANT_BASE_DOMAIN || 'rentman.al').trim();
